module.exports = __webpack_public_path__ + "img/circle_04_focus2.768acdbd.svg";